import { SortDirection } from "@tanstack/react-table";
import classNames from "classnames";
import { Inline, Stack } from "PFComponents/containers";
import { SelectV2 } from "PFComponents/select_v2";
import { Typography } from "PFComponents/typography";
import { Option } from "PFTypes/options";
import { RefObject, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "../../../../parts/overview/detail_view/detail_view.module.scss";
import cssWarningsDetail from "./warning_detail.module.scss";

type WarningsDetailProps = {
  summary: string;
  customHeader?: React.ReactNode;
  children: (selectedSort: SortDirection) => React.ReactNode;
  sidePanelRef?: RefObject<HTMLDivElement | null>;
};

export const WarningsDetail = ({ summary, customHeader, children, sidePanelRef }: WarningsDetailProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "details.warnings" });

  const sortOptions: Option<SortDirection>[] = [
    { id: "asc", value: "asc", original: "asc", displayElement: t("dateAsc") },
    { id: "desc", value: "desc", original: "desc", displayElement: t("dateDesc") }
  ];

  const [selectedSort, setSelectedSort] = useState<SortDirection>(sortOptions[0].original);

  return (
    <Stack className={classNames(css.root)} gap="spacingLg">
      <Stack gap="spacingLg">
        {customHeader}
        <Inline gap="spacingMd" alignItems="center">
          <SelectV2
            className={cssWarningsDetail.select}
            options={sortOptions}
            value={selectedSort}
            onChange={(option) => setSelectedSort((option as Option<SortDirection>).original)}
            portalRef={sidePanelRef}
          />
          <Typography withMargin variant="labelRegular" className={css.subtitle}>
            {summary}
          </Typography>
        </Inline>
      </Stack>
      {children(selectedSort)}
    </Stack>
  );
};
